// extracted by mini-css-extract-plugin
export default {"errorContainers":"formErrorsCard_errorContainers__KgXQa","errorSection":"formErrorsCard_errorSection__YCdFK"};